import React, { useMemo, useState } from 'react';
import { View, Text, TouchableOpacity, FlatList } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { ModalBottomSheet } from './ModalBottomSheet';
import { BIRTH_MONTH_LABELS, birthYearOptions } from '../utils/birthPickerData';

type Props = {
  month: string;
  year: string;
  onMonthChange: (m: string) => void;
  onYearChange: (y: string) => void;
};

export function MonthYearSelect({ month, year, onMonthChange, onYearChange }: Props) {
  const insets = useSafeAreaInsets();
  const [monthModal, setMonthModal] = useState(false);
  const [yearModal, setYearModal] = useState(false);
  const years = useMemo(() => birthYearOptions(), []);

  return (
    <View>
      <Text className="mb-2 font-medium text-zinc-900 dark:text-zinc-100">
        Bebek doğum tarihi (ay / yıl)
      </Text>
      <View className="mb-4 flex-row gap-3">
        <TouchableOpacity
          activeOpacity={0.88}
          onPress={() => setMonthModal(true)}
          className="flex-1 rounded-xl border border-zinc-200 bg-white px-4 py-3 dark:border-zinc-800 dark:bg-zinc-900">
          <Text className={month ? 'text-base text-zinc-900 dark:text-zinc-100' : 'text-base text-zinc-400'}>
            {month ? BIRTH_MONTH_LABELS.find(x => x.value === month)?.label ?? `Ay ${month}` : 'Ay seç'}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.88}
          onPress={() => setYearModal(true)}
          className="flex-1 rounded-xl border border-zinc-200 bg-white px-4 py-3 dark:border-zinc-800 dark:bg-zinc-900">
          <Text className={year ? 'text-base text-zinc-900 dark:text-zinc-100' : 'text-base text-zinc-400'}>
            {year || 'Yıl seç'}
          </Text>
        </TouchableOpacity>
      </View>

      <ModalBottomSheet
        visible={monthModal}
        onRequestClose={() => setMonthModal(false)}
        keyboardAvoiding={false}>
        <View
          className="max-h-[70%] rounded-t-3xl border border-zinc-200 bg-white px-5 pt-4 dark:border-zinc-800 dark:bg-zinc-900"
          style={{ paddingBottom: 24 + insets.bottom }}>
          <View className="mb-3 h-1 w-10 self-center rounded-full bg-zinc-200 dark:bg-zinc-700" />
          <Text className="mb-3 text-lg font-bold text-zinc-900 dark:text-zinc-100">Ay seçin</Text>
          <FlatList
            data={BIRTH_MONTH_LABELS}
            keyExtractor={item => item.value}
            keyboardShouldPersistTaps="handled"
            renderItem={({ item }) => (
              <TouchableOpacity
                onPress={() => {
                  onMonthChange(item.value);
                  setMonthModal(false);
                }}
                className={`mb-1 rounded-2xl border px-4 py-3.5 ${
                  month === item.value
                    ? 'border-zinc-900 bg-zinc-100 dark:border-zinc-100 dark:bg-zinc-800'
                    : 'border-zinc-200 bg-zinc-50 dark:border-zinc-800 dark:bg-zinc-950'
                }`}>
                <Text className="text-base text-zinc-900 dark:text-zinc-100">{item.label}</Text>
              </TouchableOpacity>
            )}
          />
        </View>
      </ModalBottomSheet>

      <ModalBottomSheet
        visible={yearModal}
        onRequestClose={() => setYearModal(false)}
        keyboardAvoiding={false}>
        <View
          className="max-h-[70%] rounded-t-3xl border border-zinc-200 bg-white px-5 pt-4 dark:border-zinc-800 dark:bg-zinc-900"
          style={{ paddingBottom: 24 + insets.bottom }}>
          <View className="mb-3 h-1 w-10 self-center rounded-full bg-zinc-200 dark:bg-zinc-700" />
          <Text className="mb-3 text-lg font-bold text-zinc-900 dark:text-zinc-100">Yıl seçin</Text>
          <FlatList
            data={years}
            keyExtractor={item => item}
            keyboardShouldPersistTaps="handled"
            renderItem={({ item }) => (
              <TouchableOpacity
                onPress={() => {
                  onYearChange(item);
                  setYearModal(false);
                }}
                className={`mb-1 rounded-2xl border px-4 py-3.5 ${
                  year === item
                    ? 'border-zinc-900 bg-zinc-100 dark:border-zinc-100 dark:bg-zinc-800'
                    : 'border-zinc-200 bg-zinc-50 dark:border-zinc-800 dark:bg-zinc-950'
                }`}>
                <Text className="text-base text-zinc-900 dark:text-zinc-100">{item}</Text>
              </TouchableOpacity>
            )}
          />
        </View>
      </ModalBottomSheet>
    </View>
  );
}
